import { callFetch } from './serviceHelpers';

export const getPrincipalById = principalId =>
  callFetch(process.env.REACT_APP_COAM_URL, 'GET', `v1/principals/${principalId}`).catch(err => {
    console.warn(err);
    return {};
  });
